import { createTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid-pro/themeAugmentation";

// カスタムカラーの型定義
declare module "@mui/material/styles" {
  interface Palette {
    brand: Palette["primary"];
    accent: Palette["primary"];
    dark: Palette["primary"];
    light: Palette["primary"];
    black: Palette["primary"];
    darkgray: Palette["primary"];
    gray: Palette["primary"];
    lightgray: Palette["primary"];
    bluegray: Palette["primary"];
    white: Palette["primary"];
    border: Palette["primary"];
  }
  interface PaletteOptions {
    brand?: PaletteOptions["primary"];
    accent?: PaletteOptions["primary"];
    dark?: PaletteOptions["primary"];
    light?: PaletteOptions["primary"];
    black?: PaletteOptions["primary"];
    darkgray?: PaletteOptions["primary"];
    gray?: PaletteOptions["primary"];
    lightgray?: PaletteOptions["primary"];
    bluegray?: PaletteOptions["primary"];
    white?: PaletteOptions["primary"];
    border?: PaletteOptions["primary"];
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    brand: true;
    accent: true;
    dark: true;
    light: true;
    black: true;
    darkgray: true;
    gray: true;
    lightgray: true;
    bluegray: true;
    white: true;
    border: true;
  }
}

export const theme = createTheme({
  typography: {
    fontWeightRegular: 400,
  },
  palette: {
    // メインカラー
    primary: {
      main: "#32788F",
    },
    secondary: {
      main: "#578FA4",
    },
    // カスタムカラー
    brand: {
      main: "#8C001C",
    },
    accent: {
      main: "#8C001C",
    },
    dark: {
      main: "#036079",
    },
    light: {
      main: "#B6CFD7",
    },
    // グレースケール
    black: {
      main: "#222222",
    },
    darkgray: {
      main: "#777777",
    },
    gray: {
      main: "#AAAAAA",
    },
    lightgray: {
      main: "#E5E5E5",
    },
    bluegray: {
      main: "#ECEFF1",
    },
    white: {
      main: "#FFFFFF",
    },
    border: {
      main: "#DDDDDD",
    },
    // 背景色
    background: {
      default: "#F0F2F4",
      paper: "#FFFFFF",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        // ボタンの角丸は 5px に統一する（画面ごとに個別指定しない）
        root: {
          borderRadius: 5,
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        columnHeaders: {
          // DataGridのヘッダーのデフォルト背景色を不透明グレーに固定する
          // これでヘッダー固定オプションを有効にした場合の不具合を防止している
          // 副作用として背景色を明示的に設定していない箇所で、ヘッダー背景色が白からグレーに変化する
          background: "rgba(246, 246, 246, 1)",
        },
      },
    },
  },
});
